export function init($name) {
    const elem = $($name);

    if (!elem.length) {
        return;
    }

    $($name + '-checkbox').change(function() {
        if(this.checked) {
            $(this).parents($name).find('input').not($name + '-checkbox').val('');
        }
    });

    $($name).find('input').not($name + '-checkbox').change(function() {
        $(this).parents($name).find($name + '-checkbox').prop('checked', false);
    });
}
